import { useContext } from 'react';
import { useIntl } from 'react-intl';

import { FocusRingVariants } from '@calm-web/design-system';

import { useAnalytics } from '@/hooks/analytics';
import messages from '@/messages/messages';

import { PreSignupFlowContext } from '../../PreSignupProvider';
import { ContinueButton, SkipButton, Wrapper } from './styles';
import { OnboardingNavButtonsProps } from './types';

const OnboardingNavButtons = ({
	onContinue,
	onCustomSkip,
	continueButtonStyle,
	continueCta,
	isTransparentSkip,
	isDisabled = false,
	skipCta,
	className,
	focusRingVariant = FocusRingVariants.Dark,
	compact,
}: OnboardingNavButtonsProps) => {
	const { formatMessage } = useIntl();
	const { skipToEnd, ActiveScreen } = useContext(PreSignupFlowContext);
	const { analyticsName, questionType, hasSkip, isDark } = ActiveScreen;
	const { logEvent } = useAnalytics();

	function onSkip(): void {
		logEvent({
			eventName: `${analyticsName} : Skipped`,
			eventProps: {
				...(questionType ? { question_type: questionType } : {}),
			},
		});
		window.scrollTo(0, 0);
		skipToEnd();
	}

	return (
		<Wrapper className={className} compact={compact}>
			{onContinue && (
				<ContinueButton
					isDisabled={isDisabled}
					fullWidth
					backgroundColor={continueButtonStyle?.backgroundColor || 'accessibleBrandGradient'}
					textColor={continueButtonStyle?.textColor || 'white'}
					onPress={onContinue}
					focusRingVariant={focusRingVariant}
					compact={compact}
				>
					{formatMessage(continueCta || messages.continue)}
				</ContinueButton>
			)}
			{(hasSkip || onCustomSkip) && (
				<SkipButton
					fullWidth
					onPress={onCustomSkip || onSkip}
					isDark={isDark}
					isTransparentSkip={isTransparentSkip}
					focusRingVariant={focusRingVariant}
				>
					{formatMessage(skipCta || messages.skipForNow)}
				</SkipButton>
			)}
		</Wrapper>
	);
};

export default OnboardingNavButtons;
